import React, { Component } from 'react'
import './App.css'
import { Link, withRouter, useParams } from 'react-router-dom'
import Axios from 'axios'
import ReactTooltip from 'react-tooltip'
import { IoIosArrowBack } from 'react-icons/io'
import Header2 from './components/Header2'
import Header_ from './components/Header'
import TopBarProgress from 'react-topbar-progress-indicator'
import Cookies from 'universal-cookie'
import { v4 as uuidv4 } from 'uuid'
import ClipLoader from 'react-spinners/BeatLoader'
import md5 from 'md5'
import Header from './layouts/Header'
import { API_URL } from './config'
const uuid = uuidv4().toUpperCase()
const uuid1 = uuidv4().toUpperCase()
const uuid2 = uuidv4().toUpperCase()
const uuid3 = uuidv4().toUpperCase()
const uuid4 = uuidv4().toUpperCase()
const uuid5 = uuidv4().toUpperCase()
const uuid6 = uuidv4().toUpperCase()

const cookies = new Cookies()
if (!cookies.get('clientid')) {
  cookies.set('clientid', uuidv4().toUpperCase())
} else {
}

class Event extends Component {
  constructor(props) {
    super(props)
    this.eventId = props.match.params.eventId
  }

  state = {
    error: null,
    products: [],
    tickets: [],
    likeLabel: '',
    liked: '',
    likes: 0,
    loadBarProgress: false,
    // eventid: 0,
    fetchingTickets: true,
    description: '',
    venue: '',
    eventName: '',
    eventDate: '',
    startTime: '',
    endTime: '',
    poster: '',
    businessId: 0,
    eventId: 0,
    campaignStatus: 'stop',
  }

  componentDidMount() {
    const eventId = this.eventId
    // const eventname = this.props.location.state.eventname;
    // const eventid = this.props.location.state.eventid;

    const query = new URLSearchParams(this.props.location.search)

    let { eventid, eventname, businessid } = 0

    document.title = 'Karamale | ' + eventname
    const customerid = query.get('customerid')
    const clientid = cookies.get('clientid')

    // get user operating system
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null

    // get devices

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows'
    } else if (/Android/.test(userAgent)) {
      os = 'Android'
    }

    // get user agent

    let browser = ''
    if (window.navigator.userAgent.indexOf('Edg/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('Edge/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('MSIE') > -1) {
      browser = 'Internet Explorer'
    } else if (
      window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Chrome') == -1
    ) {
      browser = 'Safari'
    } else if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox'
    } else if (window.navigator.userAgent.indexOf('Chrome') > -1) {
      browser = 'Chrome'
    } else if (window.navigator.userAgent.indexOf('Linux') > -1) {
      browser = 'Linux'
    }

    const device = os

    // alert(browser)

    // get likes

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETNUMBEROFLIKES&eventid=${eventId}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      this.setState({ likes: response.data.likes })
    })

    // get event details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=FETCH-EVENT-DETAILS&customerid=${customerid}&eventid=${eventId}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      this.setState({
        description: response.data.description,
        venue: response.data.venue,
        eventName: response.data.eventName,
        eventDate: response.data.eventDate,
        startTime: response.data.startTime,
        poster: response.data.poster,
        businessId: response.data.businessId,
        endTime: response.data.endTime,
        campaignStatus: response.data.campaignStatus,
      })
    })

    // Calculate impressions
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=INSERTIMPRESSION&eventid=${eventId}&businessid=${this.state.businessId}&clientid=${clientid}&device=${device}&browser=${browser}`,
      {
        withCredentials: true,
      }
    ).then((response) => {
      // alert(response.data.businessid);
    })

    // console.log("error");
    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=TICKETS&eventid=${this.eventId}`, {
      withCredentials: true,
    }).then((response) => {
      this.setState({
        tickets: response.data,
        fetchingTickets: false,
      })
    })
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const query = new URLSearchParams(this.props.location.search);

  //   const eventid = query.get("eventid");
  //   const eventname = query.get("eventname");
  //   const customerid = query.get("customerid");
  //   document.title = "Karamale | " + eventname;

  //   if (this.state.liked !== prevState.liked) {
  //     // get likes

  //     Axios.get(
  //       "https://karamale.com/apps/kscanner/webservices.php?query=GETNUMBEROFLIKES&eventid=" +
  //         eventid,
  //       {
  //         withCredentials: true,
  //       }
  //     ).then((response) => {
  //       this.setState({ likes: response.data.likes });
  //     });

  //     // Check if current customer likes the event

  //     Axios.get(
  //       "https://karamale.com/apps/kscanner/webservices.php?query=GETLIKEEVENT&customerid=" +
  //         customerid +
  //         "&eventid=" +
  //         eventid,
  //       {
  //         withCredentials: true,
  //       }
  //     ).then((response) => {
  //       if (response.data.val == 1) {
  //         this.setState({
  //           likeLabel: (
  //             <label
  //               className="color-blue font-normal small-details mt-3"
  //               onClick={() => this.like()}
  //             >
  //               Unlike
  //             </label>
  //           ),
  //         });
  //       } else {
  //         this.setState({
  //           likeLabel: (
  //             <label
  //               className="color-blue font-normal mt-3"
  //               onClick={() => this.like()}
  //             >
  //               Like
  //             </label>
  //           ),
  //         });
  //       }
  //     });

  //     Axios.get(
  //       "https://karamale.com/apps/kscanner/webservices.php?query=TICKETS&eventid=" +
  //         eventid,
  //       {
  //         withCredentials: true,
  //       }
  //     ).then((response) => {
  //       this.setState({
  //         tickets: response.data,
  //       });
  //     });
  //   }
  // }

  tickets = () => {
    const query = new URLSearchParams(this.props.location.search)

    const accountid = query.get('accountid')
    const eventDate = this.state.eventDate
    // const fulldate = this.props.location.state.fulldate;
    const customerid = query.get('customerid')
    const posterUri = `${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`
    const accounttype = query.get('accounttype')
    const customername = query.get('customername')
    const email = query.get('email')
    const phone = query.get('phone')
    const previousPage = query.get('previousPage')
    const campaignStatus = this.state.campaignStatus
    const category = query.get('category')
    let { hide, warningdiv } = ''
    const date = new Date()
    let day = date.getDate()
    if (day >= 10) {
      day = day
    } else {
      day = '0' + day
    }

    let month = date.getMonth() + 1

    if (month >= 10) {
      month = month
    } else {
      month = '0' + month
    }

    const year = date.getFullYear()
    const fulldate = year + '-' + month + '-' + day

    return (
      <div className="row justify-content-center">
        <label className="w-100 text-left">
          <label className="text-black text-bold" onClick={() => this.props.history.goBack()}>
            <ReactTooltip />
            <IoIosArrowBack size={30} className="text-black cursor-pointer" />
            &nbsp;&nbsp;Back
          </label>
        </label>
        {this.state.tickets.map((item, index) => {
          let ticket = ''

          if (item.ticket_cat == 'VVIP') {
            ticket = 'VVIP'
          } else if (item.ticket_cat == 'VIP') {
            ticket = 'VIP'
          } else {
            ticket = 'General'
          }

          {
            eventDate >= fulldate ? (hide = 'flex') : (hide = 'none')
          }

          {
            eventDate >= fulldate ? (warningdiv = 'none') : (warningdiv = 'flex')
          }
          return (
            <div className="col-12 col-lg-12 pl-1 pr-1">
              {parseInt(item.avail_tickets) <= 0 && parseInt(item.kids_tickets) <= 0 ? (
                <div className="col-12 col-lg-12 p-0">
                  <label className="ticket-btn-disabled">
                    {ticket} <span className="ticket-price">Sold out</span>
                  </label>
                </div>
              ) : (
                <div className="col-12 col-lg-12 p-0">
                  <Link
                    style={{ display: hide, textDecoration: 'none' }}
                    to={{
                      pathname: '/checkout/' + this.eventId + '/' + md5(uuid6),
                      search: `fulldate=${fulldate}
                      &eventDate=${this.state.eventDate}
                      &price=${item.price}
                      &kids_price=${item.kids_price}
                      &ticketid=${item.id}
                      &ticketref=${item.ticketref}
                      &command=1
                      &customerid=${customerid}
                      &posterUri=${this.state.poster}
                      &customername=${customername}
                      &email=${email}
                      &phone=${phone}
                      &accountid=${accountid}
                      &accounttype=${accounttype}
                      &price=${item.price}
                      &eventtype=${category}
                      &province=${this.state.province}
                      &venue=${this.state.venue}
                      &description=${this.state.description}
                      &businessid=${this.state.businessId}
                      &eventid=${this.eventId}
                      &poster=${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}
                      &eventname=${this.state.eventName}
                      &eventday=${this.state.eventDate}
                      &starttime=${this.state.startTime}
                      &endtime=${this.state.endTime}
                      &ticketid=${item.id}
                      &previousPage=${previousPage}
                      &prevPage=event
                      &campaignStatus=${campaignStatus}
                      &category=${ticket}
                      &sold=${item.sold}
                      &avail_tickets=${item.avail_tickets}
                      &kids_sold=${item.kids_sold}
                      &kids_tickets=${item.kids_tickets}`,
                      state: {
                        fromHome: true,
                        fulldate: fulldate,
                        eventDate: this.state.eventDate,
                        price: item.price,
                        ticketid: item.ticketid,
                        ticketref: item.ticketref,
                        command: 1,
                        customerid: customerid,
                        posterUri: posterUri,
                        customername: customername,
                        email: email,
                        phone: phone,
                        accountid: accountid,
                        accounttype: accounttype,
                        price: item.price,
                        category: ticket,
                        venue: this.state.venue,
                        description: this.state.description,
                        businessid: this.state.businessId,
                        eventid: this.eventId,
                        poster: this.state.poster,
                        eventname: this.state.eventName,
                        eventday: this.state.eventDate,
                        starttime: this.state.startTime,
                        endtime: this.state.endTime,
                        ticketid: item.id,
                        previousPage: previousPage,
                        prevPage: 'event',
                        campaignStatus: campaignStatus,
                      },
                    }}
                  >
                    <label className="desktop-buttons-purchase-options">
                      <label className="cancel-btn mb-0 w-100 cursor-pointer">
                        <span className=" text-15 text-black">{ticket}: </span>
                        <span class="break">
                          <br />
                        </span>
                        {/* <span className="ticket-price mobile-break"> */}
                        <label className=" mobile-break mb-0 cursor-pointer">
                          {item.price <= 0 ? (
                            ''
                          ) : (
                            <label className="mb-0 text-black font-normal cursor-pointer">
                              Adults: R{Number(item.price).toFixed(2)}
                            </label>
                          )}
                          {item.kids_price <= 0 ? (
                            ''
                          ) : (
                            <label className="mb-0 text-15 text-black font-normal cursor-pointer">
                              , Kids: R{Number(item.kids_price).toFixed(2)}
                            </label>
                          )}
                        </label>
                      </label>
                    </label>

                    <label className="ticket-btn-container small-details mb-3">
                      <label className="ticket-btn mb-0">{ticket}</label>
                      {item.price <= 0 ? (
                        ''
                      ) : (
                        <label className="mb-0">Adults: R{Number(item.price).toFixed(2)}</label>
                      )}
                      {item.kids_price <= 0 ? (
                        ''
                      ) : (
                        <label className="mb-0">
                          , Kids: R{Number(item.kids_price).toFixed(2)}
                        </label>
                      )}
                    </label>
                  </Link>
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const { error, products, loadBarProgress, fetchingTickets } = this.state

    const query = new URLSearchParams(this.props.location.search)
    const q = query.get('q')
    const queryid = query.get('id')
    const date = new Date()

    let day = date.getDate()
    if (day >= 10) {
      day = day
    } else {
      day = '0' + day
    }

    let month = date.getMonth() + 1

    if (month >= 10) {
      month = month
    } else {
      month = '0' + month
    }

    const year = date.getFullYear()
    const fulldate = year + '-' + month + '-' + day

    const eventDate = this.state.eventDate
    const poster = query.get('poster')
    const eventname = query.get('eventname')
    const eventday = this.state.eventDate
    const starttime = this.state.startTime
    const endtime = this.state.endTime
    const previousPage = query.get('previousPage')
    const campaignStatus = this.state.campaignStatus
    let backpage = ''

    {
      previousPage === 'event' ? (backpage = '') : (backpage = previousPage)
    }

    let string = ''
    {
      eventDate >= fulldate
        ? (string = '')
        : (string = (
            <label className="warning-event p-2 pb-3">
              This event has ended. Ticket sales are closed.
            </label>
          ))
    }
    if (error) {
      return <div>Error: {error.message}</div>
    } else {
      return (
        <div className="view pt-4">
          {localStorage.getItem('customername') === null ? (
            <Header />
          ) : (
            <Header />
            // <Header2 />
          )}
          {loadBarProgress && <TopBarProgress />}
          <div className="container mt-5">
            <div className="row mt-4 mb-0 w-100">
              {eventDate > fulldate ? (
                <div className="row justify-content-center align-self-center desktop-width">
                  <div className="col-lg-7 col-md-12 col-sm-12 col-12 mb-2 pl-0 pr-0">
                    <div className="content-detail">
                      <div className="">
                        <img
                          src={`${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`}
                          alt={this.state.poster}
                          width="100%"
                          className="img-poster"
                        />
                      </div>

                      <div className="col-lg-12 p-0 mt-4 pb-0">
                        <div className="pb-4">
                          <h3>{this.state.eventName}</h3>
                          <p className="mb-0 whiteSpace">
                            <span className="text-13 text-black">Date:</span>
                            <br />
                            {this.state.eventDate}
                          </p>
                          <br />

                          <p className="mb-0 whiteSpace">
                            <span className="text-13 text-black">Time:</span>
                            <br />
                            {this.state.startTime} - {this.state.endTime}
                          </p>
                          <br />

                          <p>
                            <span className="text-black text-13">Description:</span>
                            <br />
                            <div
                              className="mb-0 whiteSpace"
                              dangerouslySetInnerHTML={{
                                __html: this.state.description,
                              }}
                            />
                          </p>

                          <p className="">
                            <span className="text-black text-13">Venue:</span>
                            <br />
                            {this.state.venue}
                          </p>
                          <br />

                          <div
                            class="mapouter"
                            style={{
                              position: 'relative',
                              textAlign: 'right',
                              height: '500',
                              width: '600',
                            }}
                          >
                            <div
                              class="gmap_canvas"
                              style={{
                                overflow: 'hidden',
                                background: 'none',
                                height: '500',
                                width: '100%',
                              }}
                            >
                              <iframe
                                width="100%"
                                height="500"
                                id="gmap_canvas"
                                src={
                                  'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
                                  this.state.venue
                                }
                                frameborder="0"
                                scrolling="no"
                                marginheight="0"
                                marginwidth="0"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center align-self-center desktop-width">
                  <div className="col-lg-7 col-md-12 col-sm-12 col-12 mb-2 pl-0 pr-0">
                    <div className="content-detail">
                      <div className="">
                        <img
                          src={`${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`}
                          alt={poster}
                          width="100%"
                          className="img-poster"
                        />
                      </div>

                      <div className="col-lg-12 p-0 mt-4 pb-0">
                        <div className="pb-5">
                          <h3>{this.state.eventName}</h3>
                          <p className="mb-0 whiteSpace">
                            <span className="text-13 text-black">Date:</span>
                            <br />
                            {this.state.eventDate}
                          </p>
                          <br />

                          <p className="mb-0 whiteSpace">
                            <span className="text-13 text-black">Time:</span>
                            <br />
                            {this.state.startTime} - {this.state.endTime}
                          </p>
                          <br />

                          <p>
                            <span className="text-black text-13">Description:</span>
                            <br />
                            <div
                              className="mb-0 whiteSpace"
                              dangerouslySetInnerHTML={{
                                __html: this.state.description,
                              }}
                            />
                          </p>

                          <p className="">
                            <span className="text-black text-13">Venue:</span>
                            <br />
                            {this.state.venue}
                          </p>
                          <br />
                          <div
                            class="mapouter"
                            style={{
                              position: 'relative',
                              textAlign: 'right',
                              height: '500',
                              width: '600',
                            }}
                          >
                            <div
                              class="gmap_canvas"
                              style={{
                                overflow: 'hidden',
                                background: 'none',
                                height: '500',
                                width: '100%',
                              }}
                            >
                              <iframe
                                width="100%"
                                height="500"
                                id="gmap_canvas"
                                src={
                                  'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
                                  this.state.venue
                                }
                                frameborder="0"
                                scrolling="no"
                                marginheight="0"
                                marginwidth="0"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <br />
          <br />
          <div className="tickets-mobile">
            {localStorage.getItem('customerid') !== null ? (
              <div>
                {this.state.campaignStatus == 'running' ? (
                  <div>
                    {this.tickets()} {string}
                    {fetchingTickets && (
                      <label className="mb-0 w-100 text-center small-details">
                        <ClipLoader color={'#39c'} />
                        <br /> Just a moment...
                      </label>
                    )}
                  </div>
                ) : (
                  <div className="warning-event p-2 pb-3">
                    This event isn’t active right now. Please check back later.
                  </div>
                )}
              </div>
            ) : (
              <div className="row row-margin-bottom">
                <div className="col-12 pb-3 pl-0 pr-0">
                  Log in or Register before you can proceed
                </div>
                <div className="col-6 pl-0 pr-2">
                  <Link to="/login" className="text-underline-none">
                    <div className="text-center save-btn">Log In</div>
                  </Link>
                </div>

                <div className="col-6 pl-2 pr-0">
                  <Link to="/customer-registration" className="text-underline-none">
                    <div className="text-center cancel-btn">Register</div>
                  </Link>
                </div>
              </div>
            )}
          </div>

          <div className="event-name justify-content-center d-none" style={{ display: 'flex' }}>
            <div className="backbtn event-title justify-content-center" style={{ display: 'flex' }}>
              <div className="pt-1 pr-2"></div>
              <div className="text-center">
                {eventname}
                <br />
                <span style={{ fontSize: 13, color: 'grey', fontWeight: 400 }}>
                  {eventday} @ {starttime}
                </span>
                {/* <br />
                <label className="small-details">
                  {this.state.liked == "yes" ? (
                    <BsHeartFill color={"#ffae19"} />
                  ) : (
                    <BsHeart color={"#ffae19"} />
                  )}{" "}
                  &nbsp;{this.state.likes} &nbsp;&nbsp;
                </label>{" "}
                {this.state.likeLabel} */}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withRouter(Event)
